import React from 'react';
import { motion } from 'framer-motion';
export function AuthorSection() {
  return <section className="py-28 px-6 bg-dark" data-id="element-19">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} className="max-w-[800px] mx-auto bg-cardBg border border-border rounded-[24px] p-8 md:p-12 flex flex-col md:flex-row gap-10 items-center md:items-start" data-id="element-20">
        <img src="https://cdn.magicpatterns.com/uploads/ksPkHSMhMyFAUK2EFWZ975/gean2.jpg" alt="Gean Ortiz" className="w-[120px] h-[120px] rounded-full object-cover border-2 border-orange shrink-0" data-id="element-21" />

        <div className="text-center md:text-left" data-id="element-22">
          <h2 className="text-[28px] font-black mb-2 text-white" data-id="element-23">Gean Ortiz</h2>
          <p className="text-orange text-[16px] font-semibold mb-5" data-id="element-24">
            Estratega Digital & Especialista en Automatización con IA
          </p>

          <p className="text-[15px] text-[#AAAAAA] leading-[1.8] mb-6" data-id="element-25">
            Emprendedor, estratega digital y obsesionado con la eficiencia
            tecnológica. Durante los últimos años trabajé en servicios,
            marketing digital y automatización — experimentando de forma
            intensiva con las herramientas más avanzadas de IA y sistemas de
            captación de clientes.
            <br data-id="element-26" />
            <br data-id="element-27" />
            Mi enfoque es simple:{' '}
            <strong className="text-white" data-id="element-28">
              menos teoría, más sistemas que funcionan.
            </strong>{' '}
            Porque en esta nueva era digital, la diferencia entre un negocio que
            crece y uno que se queda atrás no es quién trabaja más duro — sino
            quién trabaja con sistemas inteligentes.
          </p>

          <div className="flex gap-6 flex-wrap justify-center md:justify-start" data-id="element-29">
            <div className="text-center" data-id="element-30">
              <span className="text-[24px] font-black text-orange block" data-id="element-31">
                50+
              </span>
              <span className="text-[12px] text-gray-400" data-id="element-32">
                Prompts maestros
              </span>
            </div>
            <div className="text-center" data-id="element-33">
              <span className="text-[24px] font-black text-orange block" data-id="element-34">
                4h
              </span>
              <span className="text-[12px] text-gray-400" data-id="element-35">Sistema probado</span>
            </div>
            <div className="text-center" data-id="element-36">
              <span className="text-[24px] font-black text-orange block" data-id="element-37">
                100%
              </span>
              <span className="text-[12px] text-gray-400" data-id="element-38">
                Herramientas gratis
              </span>
            </div>
          </div>
        </div>
      </motion.div>
    </section>;
}